import type { TFunction } from 'i18next';
import type { U3203MissionCategory } from '../U3203Service';

const NS = 'u3203';

export function u3203CategoryLabel(t: TFunction, category: string | undefined | null): string {
  switch (category as U3203MissionCategory) {
    case 'extraction':
      return t('valCategoryExtraction', { ns: NS });
    case 'assistant':
      return t('valCategoryAssistant', { ns: NS });
    case 'analyse':
      return t('valCategoryAnalyse', { ns: NS });
    default:
      return category ?? '';
  }
}

export function u3203CategoryComboItems(t: TFunction, categories: U3203MissionCategory[]) {
  return categories.map((cat) => ({
    id: cat,
    label: u3203CategoryLabel(t, cat),
  }));
}
